import { DataArray, IDataArray } from './../../shared/index';

export class DocumentPartMap implements IDataArray {
    public Id: number;
    public Part: string;
    public Value: string;
    public AttributeId: number;
    public Offset: number;
    public Created: Date;
    public Modified: Date;

    public GetById(): number {
        return this.Id;
    }
}
